var map = {
	"./1.jpg": 195,
	"./10.jpg": 196,
	"./11.jpg": 197,
	"./2.jpg": 198,
	"./3.jpg": 199,
	"./4.jpg": 200,
	"./5.jpg": 201,
	"./6.jpg": 202,
	"./7.jpg": 203,
	"./8.jpg": 204,
	"./9.jpg": 205
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 194;